type ListenerType = (...args: any[]) => void;
type DefaultEvents = 'error' | 'close';

export class EventEmitter<T extends string> {
  private readonly map = new Map<string, Set<ListenerType>>();
  private readonly onceMap = new WeakMap<ListenerType, ListenerType>();

  public on(key: T | DefaultEvents, listener: ListenerType) {
    if (!this.map.has(key)) {
      this.map.set(key, new Set());
    }
    this.listeners(key).add(listener);
    return this;
  }

  public off(key: T | DefaultEvents, listener: (...args: any[]) => void) {
    const listeners = this.map.get(key);
    if (!listeners) {
      return this;
    }
    const actualListener = this.onceMap.get(listener) || listener;
    listeners.delete(actualListener);

    if (listeners.size === 0) {
      this.map.delete(key);
    }
    return this;
  }

  public once(key: T | DefaultEvents, listener: ListenerType) {
    const listener_ = (...args: any[]) => {
      this.off(key, listener);
      listener(...args);
    };
    this.onceMap.set(listener, listener_);
    this.on(key, listener_);
    return this;
  }

  public emit(key: T | DefaultEvents, ...args: any[]) {
    if (!this.map.has(key)) {
      return;
    }
    for (const listener of this.listeners(key)) {
      try {
        listener(...args);
      } catch (err) {
        console.error(err);
      }
    }
  }

  protected listeners(key: T | DefaultEvents) {
    return this.map.get(key);
  }
}
